import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class CompanyCreditConfigService {
  getCompanyCreditConfigs(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "admin/company/credit/config/all", params);
  }
  saveCompanyCreditConfigs(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "admin/company/credit/config/save", body);
  }
}

export default new CompanyCreditConfigService();
